import React from 'react';
import { styles } from './styles';
import { withStyles, StyledComponentProps, Typography } from '@material-ui/core';
import { MenuActivities } from '../../ui-components/Icons';

const activities = (props: StyledComponentProps) => {
    return (<div className={props.classes.root}>
        <MenuActivities  className={props.classes.subHeaderIcon}/>
        <Typography className={props.classes.title} variant='h6'>Attività</Typography>
    </div>)
}

export const Activities = withStyles(styles)(activities)